var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 12,
  cy: 12,
  r: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0 2.5-3 8-10 8S2 14.5 2 12s3-8 10-8 10 5.5 10 8Z"
})));
export default SvgEye;